import React from 'react';
import PastBlastList from '../blast_sms/PastBlastList';

function SmsNewsletter() {
    return (
        <PastBlastList
            title="Past SMS Newsletter"
            description="Track SMS newsletters from queueing through send completion."
            icon="bi-chat-text"
            type="SMS"
            category="NEWSLETTER"
            entityLabel="Newsletter"
            createPath="/newsletter/create-sms"
            createLabel="Create SMS Newsletter"
            resultsBasePath="/newsletter/sms"
            emptyTitle="No SMS newsletters yet"
            emptyDescription="Create an SMS newsletter to message selected patients. Past launches will show here with status."
            infoText="Only patients with a cell number who have not opted out of SMS newsletters are eligible. Large newsletters queue in the background and show as In progress until ready. While Pending, you can Stop a newsletter before it sends. Use Results after a newsletter completes or errors."
        />
    );
}

export default SmsNewsletter;
